import Vue from 'vue'
import { randomString } from './uilt'
const space = 0, ids = []
export function createChartDom(child = "<div></div>", width, height) {

    let dom = document.createElement('div')
    let id = `chart_${randomString()}_${new Date().getTime()}`
    ids.push(id)
    dom.id = id
    dom.style.width = `${width}px`
    dom.style.height = `${height}px`
    if (child instanceof Object) {
        dom.appendChild(child)
    } else {
        dom.innerHTML = child
    }
    return dom
}

//清除创建的dom
export function removeChartDom() {
    ids.filter(o => {
        let dom = document.getElementById(o)
        if (dom)
            dom.remove()
    })
}
//隐藏创建的dom
export function hideChartDom() {
    ids.filter(o => {
        let dom = document.getElementById(o)
        if (dom)
            dom.style.display = 'none'

    })
}
//显示创建的dom
export function showChartDom() {
    ids.filter(o => {
        let dom = document.getElementById(o)
        // console.log('显示', o)
        if (dom)
            dom.style.display = 'block'
    })
}
export function convertVueToHtml(template, props,) {
    let tipComponent = Vue.extend({
        render: (h) =>
            h(template, {
                props: props, //组件传值
            }),
    }); //生成组件的dom
    let component = new tipComponent().$mount();
    return component.$el;
}


